<div class="row g-4">
    @if (access.appointmentAging) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Appointment Aging">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadAppointmentAging"
                    [palette]="palettes.appointmentAging"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.tagsRequired) {
        <div class="col-12 col-lg-6">
            <app-dashboard-card title="Tags Required">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadTagsRequired"
                    [palette]="palettes.tagsRequired"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.inboundProductivity) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="Inbound Productivity">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadInboundProductivity"
                    [palette]="palettes.inboundProductivity"
                    centerText="Trailers"
                    formatMode="decimal"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.appointmentCompliance) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="Compliance">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadAppointmentCompliance"
                    [palette]="palettes.appointmentCompliance"
                    [legendExclude]="['Remaining']"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }

    @if (access.damaged210) {
        <div class="col-12 col-lg-4">
            <app-dashboard-card title="210 Damage">
                <app-doughnut-chart
                    [from]="from"
                    [to]="to"
                    [loadData]="loadDamaged210"
                    centerText="My Score"
                    [useCapitalCaseFormatting]="false"
                    [scoreCountsAsData]="true"
                    [responsive]="false"
                ></app-doughnut-chart>
            </app-dashboard-card>
        </div>
    }
</div>
